// @flow
import type { AppState } from 'modules/rootReducer';

const getCampaignDetails = (state: AppState): null => {
  if (state.CampaignPageReducer.campaignDetails)
    return state.CampaignPageReducer.campaignDetails;
  else return [];
};

const getCampaignDetailsLoading = (state: AppState): boolean => {
  return state.CampaignPageReducer.loading.campaignDetails;
};

const getCampaignDetailsError = (state: AppState): string | null => {
  return state.CampaignPageReducer.error.campaignDetails;
};

export const CampaignSelector = {
  getCampaignDetails,
  getCampaignDetailsLoading,
  getCampaignDetailsError,
};
